module.exports = __webpack_public_path__ + "static/media/warning.f2833da8.svg";